<template>
  <div class="app_cp">
    <div class="pay1" v-if="payType == '1'">
    </div>
    <div class="pay2" v-else></div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const payType = ref(route.query.type)
watch(
  () => route.query.type,
  (newType) => {
    payType.value = newType || ''
  }
)

</script>

<style scoped lang="less">
.app_cp {
  width: 100%;
  height: 80%;
  .pay1 {
    background: url('@/assets/login/pay.png') no-repeat center center;
    background-size: 100% 100%;
    width: 836px;
    height: 620px;
    margin: 0 auto;
  }
  .pay2 {
    background: url('@/assets/login/pay2.png') no-repeat center center;
    background-size: 100% 100%;
    width: 836px;
    height: 620px;
    margin: 0 auto;
  }
}
</style>
